<template>
  <div style="background-color: #f1f3f6; padding: 0 40px;">
    <div class="header">
      <div class="">
        <img src="https://image-yoshino.sakura.ne.jp/monster/SaleMonAgentH.png" alt="" class="img-responsive">
      </div>
      <div class="text-primary font-bold">セルモンエージェントとは、セラー様にとってお得になる情報をご提案するサービスです！</div>
    </div>
    <div style="">
      <nav-tabs :tab="tab"></nav-tabs>
      <tab-content :tab="tab"></tab-content>
    </div>
  </div>
</template>

<script>
import NavTabs from './NavTabs'
import TabContent from './TabContent'
import tabs from '@/common/salemon-agent-tabs'

export default {
  components: {
    NavTabs,
    TabContent
  },
  data () {
    return {
      tab: null,
      loader: null
    }
  },
  computed: {
    allowTabs () {
      return tabs.map(tab => tab.id)
    }
  },
  created () {
    this.tab = this.$route.params.tab
    if (!this.$store.getters.getUser.hasReturnRecommend || (this.tab && !this.allowTabs.includes(this.tab))) {
      this.$router.push('/not-found')
    }
  },
  mounted () {
    this.$events.listen('handleError', (err, modalWidth = 400) => {
      this.$store.commit('toggleModal', {
        show: true,
        message: err,
        modalWidth: modalWidth
      })
    })
  },
  methods: {
  },
  watch: {
    $route (to) {
      const toTab = to.params.tab
      if (toTab && !this.allowTabs.includes(toTab)) {
        this.$router.push('/not-found')
      } else {
        this.tab = toTab
      }
    }
  },
  beforeDestroy () {
    this.$events.remove('done')
    this.loader && this.loader.hide()
  }
}
</script>

<style scoped>
.header {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-bottom: 10px;
}
.text-primary {
  color: #008cc6;
}
</style>



// WEBPACK FOOTER //
// src/view/salemonAgent/SalemonAgent.vue